import { Button, Form, Input, Radio } from "antd";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";

export default function EmailLogin({ onsubmit = () => {}, isLoading }) {
  const [form] = Form.useForm();
  const recaptchaRef = useRef();

  return (
    <Form form={form} onFinish={() => onsubmit({ ...form.getFieldsValue(), captcha: recaptchaRef.current?.getValue() })} layout="vertical">
      <Form.Item name="type" initialValue="email" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="type_value" rules={[{ required: true, message: "Please enter your email!" }]}>
        <Input placeholder="Email address" />
      </Form.Item>
      <Form.Item name="password" rules={[{ required: true, message: "Please enter your password!" }]}>
        <Input type="password" placeholder="password" />
      </Form.Item>
      <Form.Item name="provider" initialValue="mpki" label="Provider:">
        <Radio.Group>
          <Radio value="mpki">Mobile ID</Radio>
          <Radio value="gasr">App ID</Radio>
        </Radio.Group>
      </Form.Item>
      <div style={{ marginBottom: 20, marginTop: 20, display: "flex", justifyContent: "center" }}>
        <ReCAPTCHA ref={recaptchaRef} sitekey="6LdaJr0eAAAAALCSKgUTcO3z6fZaYMdWsXUf-F7_" />
      </div>
      <Button block shape="round" loading={isLoading} className="login_button" htmlType="submit">
        Continue
      </Button>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/mobile">
          Login with Mobile Number
        </Link>
      </div>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/forgot">
          Forgot Password
        </Link>
      </div>
    </Form>
  );
}
